// extracted by mini-css-extract-plugin
export var boxItems = "_8y-1";
export var boxItemsLg = "_8y-2";
export var button = "_8y-7";
export var buttonLg = "_8y-8";
export var filterGroupBox = "_8y-0";
export var icon = "_8y-3";
export var iconSecondary = "_8y-6";
export var iconWrapper = "_8y-4";
export var iconWrapperLg = "_8y-5";